import { Button, Menu, Text, Tooltip, VisuallyHidden } from "@mantine/core";
import { Check } from "lucide-react";

import classes from "./editor.module.css";
import { ORIGINALS_NOTE, QUALITIES, type PreviewQuality, type QualityWords } from "./quality";

/**
 * The preview-quality pill at the canvas's top right (spec editor/proxy-playback.md, the D6 layouts
 * page's card 23): what the preview plays, its counts in the tooltip, and the menu that chooses the
 * copies or the originals in this browser, a check on the chosen one and the note under them.
 */
export function QualityPill(props: {
  words: QualityWords;
  quality: PreviewQuality;
  onQuality: (quality: PreviewQuality) => void;
}) {
  const { words, quality, onQuality } = props;
  const tip = (
    <span className={classes.qualityTip}>
      {words.details.map((line) => (
        <span key={line}>{line}</span>
      ))}
    </span>
  );
  return (
    <Menu position="bottom-end" width={256}>
      <Tooltip label={tip} multiline maw={300} withArrow position="bottom-end">
        <Menu.Target>
          <Button variant="default" className={classes.aspectButton} aria-label={`Preview quality: ${words.label}`}>
            {words.label}
          </Button>
        </Menu.Target>
      </Tooltip>
      <Menu.Dropdown>
        {QUALITIES.map(({ value, label }) => {
          const chosen = value === quality;
          const check = chosen ? <Check size={16} color="var(--cai-color-primary)" aria-hidden /> : null;
          return (
            <Menu.Item key={value} rightSection={check} onClick={() => onQuality(value)}>
              {label}
              {chosen ? <VisuallyHidden>, current</VisuallyHidden> : null}
            </Menu.Item>
          );
        })}
        <Menu.Divider />
        <Text size="xs" c="var(--cai-color-text-muted)" className={classes.qualityNote}>
          {ORIGINALS_NOTE}
        </Text>
      </Menu.Dropdown>
    </Menu>
  );
}
